<template>
    <app-layout>
        <common-content-spacer height="medium">
            <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            <common-page-header :heading="pageTitle" size="medium"></common-page-header>
            <common-page-plain>
                <patient-header-layout></patient-header-layout>
                <common-content-spacer height="large">
                    <patient-name :physician="patientDetails" @toggle="toggleModal"></patient-name>
                </common-content-spacer>
                <common-page-split spacing="medium" class="doc-layout">
                    <template #aside>
                        <patient-sidebar :physician="patientDetails" @toggle="toggleModal"></patient-sidebar>
                    </template>
                    <template #main>
                        <common-content-spacer height="large">
                            <patient-detail-form
                                :physician="{
                                    PatientRecord: isPatientRecordModalOpen,
                                    PatientMessage: isPatientMessageModalOpen,
                                    CheckPassword: isCheckPasswordModalOpen,
                                    DeletePatient: isDeletePatientModalOpen,
                                    DirectReferral: isDirectReferralModalOpen,
                                }"
                                :patientDetails="patientDetails"
                                @toggle="toggleModal"
                            ></patient-detail-form>
                        </common-content-spacer>
                    </template>
                </common-page-split>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>
<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientDetailForm from 'components/forms/patient/PatientDetailForm'
    import PatientSidebar from 'components/forms/patient/PatientSidebar'
    import PatientHeaderLayout from 'components/forms/patient/PatientHeaderLayout'
    import PatientName from 'components/forms/patient/PatientName'
    import PatientAPI from 'api/PatientAPI'
    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientDetailForm,
            PatientSidebar,
            PatientHeaderLayout,
            PatientName,
        },

        data() {
            return {
                isPatientRecordModalOpen: false,
                isPatientMessageModalOpen: false,
                isCheckPasswordModalOpen: false,
                isDeletePatientModalOpen: false,
                isDirectReferralModalOpen: false,
                patientDetails: {},
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.patient.details.titles.patient_title', { patientTitle: 'Patient' })
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient'),
                        route: { name: 'practice.profile' },
                    },
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient_details'),
                    },
                ]
            },
        },
        methods: {
            toggleModal(name) {
                switch (name) {
                    case 'toggle-patient-record-modal':
                        this.isPatientRecordModalOpen = !this.isPatientRecordModalOpen
                        break
                    case 'toggle-patient-message-modal':
                        this.isPatientMessageModalOpen = !this.isPatientMessageModalOpen
                        break
                    case 'toggle-check-password-modal':
                        this.isCheckPasswordModalOpen = !this.isCheckPasswordModalOpen
                        break
                    case 'toggle-delete-patient-modal':
                        this.isDeletePatientModalOpen = !this.isDeletePatientModalOpen
                        break
                    case 'toggle-direct-referral-modal':
                        this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
                        break
                }
            },
            loadData() {
                const patientId = this.$route.params.id
                PatientAPI.getPatientDetails(patientId, this.$auth.getUser().id)
                    .then((res) => {
                        this.patientDetails = res
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
        mounted() {
            this.loadData()
        },
    }
</script>
<style>
    .patient-detail-form-text input:disabled {
        border: 0 !important;
        opacity: 1 !important;
        background-color: transparent !important;
    }
    .patient-detail-form-text.form-field--is-disabled .form-field__label {
        opacity: 1 !important;
        font-weight: 600 !important;
        padding-left: 14px !important;
    }
    .patient-detail-form-text .form-phone-input__area-code.form-phone-input__area-code--disabled {
        opacity: 1 !important;
        border: 0 !important;
        width: 20px !important;
        padding-left: 15px;
    }
    .patient-detail-form-text.form-input-select--is-disabled .form-input-select__input {
        border: 0 !important;
    }
    .form-input-select--is-disabled .form-input-select__input {
    }
    .doc-layout {
        border: 0 !important;

        .page-split__aside {
            width: unset !important;
        }
    }
</style>
